import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-down-arrow",
  "use": "icon-down-arrow-usage",
  "viewBox": "0 0 11 7",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 11 7\" id=\"icon-down-arrow\"><path d=\"M11.054 1.017L5.527 6.543 0 1.017 1.016 0s4.487 4.454 4.51 4.454c.024 0 .718-.667 4.511-4.454z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol